import { CSSProperties } from "react";
import SideMenu from "Components/SideMenu";

const styles: CSSProperties = {
  backgroundImage: `url(${process.env.PUBLIC_URL}/commons/bg-main.png)`,
};

interface LayoutProps {
  children?: any;
  theme?: CSSProperties | null;
  hiddenBar?: boolean;
  hiddenBg?: boolean | null;
}

const Layout = ({ children, theme, hiddenBar, hiddenBg }: LayoutProps) => {
  return (
    <>
      {!hiddenBar && <SideMenu />}
      <div
        style={theme ? theme : hiddenBg ? {} : styles}
        className={"main-container"}
      >
        {children}
      </div>
    </>
  );
};

export default Layout;
